module.exports = __webpack_public_path__ + "static/img/bao.37c3ea6b.jpg";